<template>
  <div class="amap-page-container">
    <div
      id="container"
      style="width:100%; height:100%"
      v-if="map != null"
    ></div>
    <div class="no-data" v-else>
      <div class="wrap">
        <div class="no_data_img"></div>
        <p class="p1">未获取到飞行轨迹</p>
        <p class="p2">如有疑问请联系：0571-57888678</p>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../../http";
import { mapState } from "vuex";
// import AMap from "AMap";
import MapLoader from "../../common/js/map";

export default {
  name: "maps",
  components: {},
  props: {},
  computed: {
    ...mapState(["token"])
  },
  data() {
    return {
      mapArr: [],
      map: null,
      getTileUrl:
        "http://mt{1,2,3,0}.google.cn/vt/lyrs=s&hl=zh-CN&gl=cn&x=[x]&y=[y]&z=[z]&s=Galile"
    };
  },
  mounted() {
    this.getMapData();
    let that = this;
  },
  watch: {
    mapArr() {
      this.init();
    }
  },
  methods: {
    init() {
      MapLoader("e17729493a67c97efae00e1efed47c28").then(AMap => {
        var googleLayer = new AMap.TileLayer({
          getTileUrl: this.getTileUrl
        });
        var map = new AMap.Map("container", {
          resizeEnable: true,
          center: this.mapArr[0].path[0],
          zoom: 13,
          strokeWeight: 1,
          layers: [googleLayer]
        });
        var polylines = "";
        this.mapArr.forEach(el => {
          var polyline = new AMap.Polyline({
            path: el.path,
            strokeColor: el.strokeColor
            // 折线样式还支持 'das
          });
          polyline.setMap(map);
          polylines = polyline;
        });

        // 缩放地图到合适的视野级别
        map.setFitView([polylines]);
      });
    },
    getMapData() {
      axios
        .fetchPost("/api/order/points", {
          token: this.token,
          order_sn: this.$route.query.order_sn,
          user_id: this.$route.query.user_id
        })
        .then(res => {
          let data = res.data;
          if (data.code == 200) {
            data.data.forEach((el, index) => {
              el.paths.forEach((item, cindex) => {
                this.mapArr.push({
                  path: item,
                  strokeColor: el.color
                });
              });
            });
          } else {
            // this.$toast(res.data.msg);
            // setTimeout(() => {
            //   this.$router.go(-1);
            // }, 2000);
          }
        })
        .catch(e => {
          console.log("e :", e);
        });
    }
  },
  destroyed() {
    this.getTileUrl = null;
  }
};
</script>
<style lang="stylus" scoped>
.amap-page-container
  height 100%
  overflow hidden
  .amap-demo
    height 100%
    width 50%
    float left
  #map
    height 100%
    width 50%
    position absolute
    right 0
    top 0px
    border 1px solid red
    float left
/* 隐藏ol的一些自带元素 */
.ol-attribution, .ol-zoom
  display none
.no-data
  width 100%
  height 100%
  position relative
  background #f8f8f8
  color #999
  .wrap
    position absolute
    left 0
    right 0
    top 45%
    transform translateY(-50%)
  .no_data_img
    width 134px
    height 87px
    background url('./no_data.png') no-repeat
    background-size 100% 100%
    background-position center center
    margin 0 auto 25px
  p
    color #999
    text-align center
    font-size 14px
    font-family: Microsoft YaHei;
    line-height 24px
</style>
